"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = ({
  size = 50,
  width = size,
  height = size,
  ...restProps
}) => /*#__PURE__*/_react.default.createElement("svg", _extends({
  width: width,
  height: height,
  viewBox: "-5 -5 50 50",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, restProps), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "20",
  cy: "20",
  r: "20",
  fill: "#384454"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M18.606 22.88H21.0539C21.0539 20.4966 24.8002 19.5917 24.8002 16.2372C24.8002 13.4566 22.5013 12 20.1386 12C17.9674 12 16.0091 13.1034 15.2002 15.2662L17.3075 16.5021C17.7332 15.2 18.7337 14.4717 20.0747 14.4717C21.437 14.4717 22.3523 15.1117 22.3523 16.3917C22.3523 18.7972 18.606 19.6359 18.606 22.88ZM19.8405 28C20.7133 28 21.437 27.2497 21.437 26.3448C21.437 25.4179 20.7133 24.6897 19.8405 24.6897C18.9465 24.6897 18.2441 25.4179 18.2441 26.3448C18.2441 27.2497 18.9465 28 19.8405 28Z",
  fill: "white"
}));

exports.default = _default;